export default {"src":"/_next/static/media/tix.ac19a8ff.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};